export default "__VITE_ASSET__BdenON5m__"